<template>
	<div>
		<div class="bg"></div>
		<div class="modal">
			<div class="closeBtn" @click="hideModal">x</div>
			<div class="modalTitle">新增常用观影人</div>
			<div class="infoItem">
				<span class="title">观影人类型</span>
				<div class="selList">
					<div class="selItem" v-for='(typeItem,index) in typeGroup' @click="selType(index)">
						<img :src="typeIndex==index?selIcon:unSelIcon" class="selIcon"></img>
						<span class="name">{{typeItem.name}}</span>
					</div>
				</div>
			</div>
			<div class="infoItem">
				<span class="title">姓名</span>
				<input class="input" placeholder="请输入姓名" v-model="inputList[0].val"></input>
			</div>
			<div class="infoItem">
				<span class="title">身份证号码</span>
				<input class="input" placeholder="请输入身份证号码" v-model="inputList[1].val"></input>
			</div>
			<div class="infoItem">
				<span class="title">手机号</span>
				<input class="input" maxlength='11' placeholder="请输入手机号" v-model="inputList[2].val"></input>
			</div>
			<div class="saveBtn" @click="save">保存</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['editObj'],
		data() {
			return {
				selIcon: require('@/assets/img/idVerify/isSel.png'),
				unSelIcon: require('@/assets/img/idVerify/isUnSel.png'),
				typeIndex: 0,
				typeGroup: [{
						name: '成人'
					},
					{
						name: '儿童'
					},
					{
						name: '学生'
					},
				],
				inputList: [{
						name: '姓名',
						val: ''
					},
					{
						name: '身份证号码',
						val: ''
					},
					{
						name: '手机号',
						val: ''
					},
				]
			}
		},
		created: function() {
			//编辑模式进来--更新观影人类型
			if (this.editObj.id) {
				this.typeIndex = this.editObj.type;
				this.inputList[0].val = this.editObj.name;
				this.inputList[1].val = this.editObj.idCard;
				this.inputList[2].val = this.editObj.tel;
			}
		},
		methods: {
			selType: function(index) {
				this.typeIndex = index;
			},
			save: function() {
				/* -- 编辑模式 -- */
				if (this.editObj.id) {
					this.axiosEditId();
				}
				/* -- 新增模式 -- */
				else {
					this.axiosAddId();
				}
			},
			axiosEditId: function() {
				var that = this;
				that.axios.post('/resUrl/api/customer/put', {
						token: that.$store.state.userInfo.token,
						group_id: that.$store.state.group_id,
						id: that.editObj.id,
						real_name: that.inputList[0].val,
						id_card_number: that.inputList[1].val,
						mobile: that.inputList[2].val,
						type: Number(that.typeIndex) + 1
					})
					.then(function(res) {
						if (res.data.code == 0) {
							that.$emit('sucSave');
						} 
					})
			},
			axiosAddId: function() {
				var that = this;
				that.axios.post('/resUrl/api/customer/save', {
						token: that.$store.state.userInfo.token,
						group_id: that.$store.state.group_id,
						real_name: that.inputList[0].val,
						id_card_number: that.inputList[1].val,
						mobile: that.inputList[2].val,
						type: Number(that.typeIndex) + 1
					})
					.then(function(res) {
						if (res.data.code == 0) {
							that.$emit('sucSave');
						} else {
							that.global.axiosErr(that, res)
						}
					})
					.catch(function() {
						that.$message.error('连接超时')
					});
			},
			hideModal: function() {
				this.$emit('hideModal');
			}
		}
	}
</script>

<style scoped src='@/assets/css/idCards/add-idCard.css'>
</style>
